<template>
  <div id="content">
    <Search/>
    <div class="container">
      <div class="breadcrumb-wrap">
        <v-breadcrumbs :items="breadcrumbs"/>
      </div>
    </div>

    <div class="view-npa-public offer-view">
      <div class="container">
        <div class="position">
          <div class="bg-white p-20">
            <div v-if="offer">
              <div class="offer-view-head">
                <div class="view-npa-analytics">
                  <div class="analytics-col">
                    <div class="subscripbe">
                      <a href="#">
                        <img src="@/assets/subscibe.png" alt="subscibe"/>
                        {{ $t("Подписаться") }}
                      </a>
                    </div>
                    <div class="print-v">
                      <a href="#">
                        <img src="@/assets/print.png" alt="print"/>{{ $t("Версия для печати") }}
                      </a>
                    </div>
                    <div class="analytics">
                      <span class="views">
                        <i class="pro-icon-eye"></i> {{ views }}
                      </span>
                      <span class="comments">
                        <i class="pro-icon-like"></i> {{ pros }}
                      </span>
                      <span class="messages">
                        <i class="pro-icon-dislike"></i> {{ cons }}
                      </span>
                    </div>
                  </div>
                  <div class="analytics-col">
                    <router-link
                      active-class="active"
                      :to="$i18nRoute({ name: 'offer-create' })"
                      class="btn-post-offer"
                    >
                      <i class="pro-icon-edit-2"></i> {{ $t("Разместить предложение") }}
                    </router-link>
                  </div>
                </div>
              </div>
              <div class="offer-view-body">
                <h4 class="offer-title">{{ offer.title }}</h4>
                <div v-if="offer.content" v-html="offer.content"></div>
                <div v-if="offer.file" class="offer-view-file">
                  <a :href="baseUrl + offer.fullFilesDirectory">{{ offer.file }} </a>
                </div>
                <div>
                  <p>{{ $t("Тип предложения") }}: {{ offer.type ? offer.type.transName: $t("не указано") }}</p>
                  <p>{{ $t("Государственные органы, которые могут помочь реализовать Ваше предложение") }}: {{ developers ? developers : $t("не указано") }}</p>
                </div>
              </div>
              <div class="share-soc">
                <div class="voting">
                  <a @click.prevent="createVote(like)">{{ $t("Проголосовать") }} “{{ $t("ЗА") }}”</a>
                  <a @click.prevent="createVote(dislike)">{{ $t("Проголосовать") }} “{{ $t("ПРОТИВ") }}”</a>
                  <a v-if="!isLoggedIn()" @click="showNoty">{{ $t("Пожаловаться") }}</a>
                  <v-menu
                    v-if="isLoggedIn()"
                    v-model="menu"
                    :close-on-content-click="false"
                    offset-y
                    class="complaint"
                  >
                    <template v-slot:activator="{ on }">
                      <a v-on="on">{{ $t("Пожаловаться") }}</a>
                    </template>
                    <v-textarea
                      outlined
                      auto-grow
                      rounded
                      rows="1"
                      placeholder="Текст жалобы..."
                      v-model="appeal"
                      full-width
                      class="complaint-form-text"
                    />
                    <button
                      @click="sendAppeal(offer.id)"
                      class="btn-send"
                      style="display: block"
                    />
                  </v-menu>
                </div>
                <div class="share-icons">
                  <Social
                    :url="currentUrl"
                    :title="offer.title"
                    :content="offer.content"
                    :quote="offer.title"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import Search from '@/components/Search'
  import Social from '@/components/Social'
  import {mapMutations} from 'vuex'
  import Offer from '@/model/offer'
  import {Trans} from "@/plugins/Translation"

  export default {
    components: {
      Search,
      Social
    },
    data() {
      return {
        baseUrl: process.env.VUE_APP_BACK_URL,
        currentUrl: '',
        offer: null,
        developers: null,
        parent: null,
        appeal: null,
        menu: null,
        like: null,
        dislike: null,
        pros: 0,
        cons: 0,
        showBlock: false,
        breadcrumbs: [],
        title: '',
        description: '',
        keywords: ''
      }
    },
    computed: {
      views() {
        return this.offer.views ? this.offer.views : 0
      },
    },
    metaInfo() {
      return {
        title: this.title,
        meta: [{
          vmid: 'description',
          name: 'description',
          content: this.description,
        }, {
          vmid: 'keywords',
          name: 'keywords',
          content: this.keywords,
        }]
      }
    },
    mounted() {
      this.fetchData()
      this.currentUrl = window.location.href
    },
    created() {
      this.scrollToTop()
    },
    methods: {
      isLoggedIn() {
        return this.$store.getters.isLoggedIn
      },
      ...mapMutations(['setLoading']),
      fetchData() {
        this.setLoading(true)
        Offer.getOffer(this.$route.params.id).then((response) => {
          this.parent = response.data.parentMenu
          this.offer = response.data.offer
          this.developers = response.data.developers
          const voiceTypes = response.data.voiceTypes
          this.like = voiceTypes.like
          this.dislike = voiceTypes.dislike
          this.setLoading(false)
          this.pros = this.offer.offer_votes.filter(
            (v) => v.voice_type.id === this.like
          ).length
          this.cons = this.offer.offer_votes.length - this.pros
          const breadcrumb = {}
          const breadcrumbItem = {}
          this.breadcrumbs = [{text: this.$i18n.t('Главная'), disabled: false, href: Trans.currentLocaleUrl + '/'}]
          if (this.parent) {
            breadcrumbItem.text = this.parent.transTitle
            //console.log(breadcrumbItem.text)
            breadcrumbItem.disabled = false
            breadcrumbItem.href = Trans.currentLocaleUrl + '/offer'
          }
          breadcrumb.text = this.offer.title
          breadcrumb.disabled = true
          this.breadcrumbs.push(breadcrumbItem, breadcrumb)
          this.title = this.offer.title
          this.description = this.offer.content
          this.keywords = this.offer.content
        })
      },
      sendAppeal(id) {
        Offer.createAppeal(id, {appeal: this.appeal})
          .then((response) => {
            let result = response.data
            if (result.result == 'success') alert(this.$i18n.t('Жалоба добавлена'))
          })
          .catch((error) => {
            alert(error.response.data.error)
          })

        this.appeal = ''
        this.menu = false
      },
      createVote(voiceType) {
        if (!this.isLoggedIn())
        {
          this.showNoty()
        } else {
          Offer.createVote(this.offer.id, voiceType)
            .then((response) => {
              let result = response.data
              if (result.result == 'success' && voiceType === this.like) {
                alert(this.$i18n.t('Вы успешно проголосовали ЗА'))
                this.pros++
              } else if (result.result == 'success' && voiceType === this.dislike) {
                alert(this.$i18n.t('Вы успешно проголосовали ПРОТИВ'))
                this.cons++
              }
            })
            .catch((error) => {
              let message =
                error.response.status === 403
                  ? 'У вас нет прав для голосования'
                  : error.response.data.error
              alert(message)
            })
        }
      },
      showNoty() {
        this.$noty.warning(this.$i18n.t('Чтобы проголосовать или пожаловаться необходимо авторизоваться или зарегистрироваться'), {
          killer: true,
          timeout: 3000,
          layout: 'topRight',
        }).on('onClose', () => {
          this.$router.push(Trans.i18nRoute({ name: 'login' }))
        })
      },
      scrollToTop() {
        window.scrollTo(0, 0)
      }
    }
  }
</script>

<style lang="scss" scoped>
  .offer-title {
    text-align: center;
  }

  .v-menu__content {
    background: #fff;
    box-shadow: none;
  }
</style>
